module.exports = __webpack_public_path__ + "static/img/khk001-logo_03.d70d81e0.png";